import BNBox from "../BNBox/BNBox";
import { useTheme } from "@mui/material";

const BNBackgroundEffect: React.FC = () => {
  var theme = useTheme();

  return (
    <BNBox
      sx={[
        { display: "none" },
        theme.applyStyles("dark", {
          position: "fixed",
          display: "block",
          inset: 0,
          pointerEvents: "none",
          zIndex: -1,
          overflow: "hidden",
          "@keyframes floatBulb": {
            "0%": { transform: "translate(0, 0)", opacity: 0.6 },
            "12%": { transform: "translate(60vw, 3rem)", opacity: 0.9 },
            "25%": { transform: "translate(100vw, -8rem)", opacity: 0.5 },
            "37%": { transform: "translate(70vw, -18rem)", opacity: 0.8 },
            "50%": { transform: "translate(30vw, -20rem)", opacity: 0.4 },
            "62%": { transform: "translate(10vw, -12rem)", opacity: 0.7 },
            "75%": { transform: "translate(50vw, -5rem)", opacity: 0.95 },
            "87%": { transform: "translate(20vw, 2rem)", opacity: 0.5 },
            "100%": { transform: "translate(0, 0)", opacity: 0.6 },
          },
          "@keyframes floatBulbReverse": {
            "0%": { transform: "translate(100vw, -20rem)", opacity: 0.5 },
            "12%": { transform: "translate(50vw, -18rem)", opacity: 0.8 },
            "25%": { transform: "translate(0, -12rem)", opacity: 0.45 },
            "37%": { transform: "translate(20vw, -3rem)", opacity: 0.9 },
            "50%": { transform: "translate(70vw, 0)", opacity: 0.55 },
            "62%": { transform: "translate(90vw, 3rem)", opacity: 0.85 },
            "75%": { transform: "translate(40vw, -6rem)", opacity: 0.4 },
            "87%": { transform: "translate(80vw, -15rem)", opacity: 0.75 },
            "100%": { transform: "translate(100vw, -20rem)", opacity: 0.5 },
          },
          "&::before": {
            content: '""',
            position: "absolute",
            top: "-14rem",
            left: "-90vw",
            width: "180vw",
            height: "70rem",
            background:
              "radial-gradient(ellipse at center, rgb(22 112 195 / 53%) 0%, rgba(30, 60, 160, 0.12) 40%, transparent 70%)",
            filter: "blur(3rem)",
            willChange: "transform, opacity",
            animation: "floatBulbReverse 30s ease-in-out infinite",
            "@media (prefers-reduced-motion: reduce)": {
              animation: "none",
              transform: "translate(40vw, -10rem)",
              opacity: 0.6,
            },
          },
          "&::after": {
            content: '""',
            position: "absolute",
            top: "4rem",
            left: "-90vw",
            width: "180vw",
            height: "70rem",
            background:
              "radial-gradient(ellipse at center, #f47f7f6e 0%, rgba(244, 127, 127, 0.1) 40%, transparent 70%)",
            filter: "blur(3rem)",
            willChange: "transform, opacity",
            animation: "floatBulb 30s ease-in-out infinite",
            "@media (prefers-reduced-motion: reduce)": {
              animation: "none",
              transform: "translate(60vw, -8rem)",
              opacity: 0.5,
            },
          },
        }),
      ]}
    />
  );
};

export { BNBackgroundEffect };
